const Chat = () => {
  const el = {
    button: document.getElementById("chat-button"),
    contact: document.querySelector(".contact"),
    contactTrigger: document.querySelector(".contact__trigger"),
  };

  const method = {
    init: () => {
      if (el.button) {
        el.button.addEventListener("click", () => {
          if (el.contactTrigger) {
            el.contactTrigger.setAttribute("aria-hidden", "false")
          }

          if (el.contact) {
            el.contact.classList.add("contact--transitioning");
            el.contact.classList.add("contact--minimized");

            setTimeout(() => {
              method.appendText()
              el.contact.classList.remove("contact--transitioning");
            }, 500);
          }
        });
      }
    },

    appendText() {
      const inputs = document.querySelector('.cx-form-inputs')
      let culture = "IS";
      culture = document.documentElement.lang.toUpperCase();

      if (inputs) {
        const text = document.createElement('div')
        
        if (culture && culture === "EN") {
          text.innerHTML = 'By starting Web chat you allow VR to use the provided personal information to provide you services. All communication are stored in a database.'
        } else {
          text.innerHTML = 'Með því að hefja vefspjall leyfir þú VR að nota persónuupplýsingar sem gefnar eru upp svo hægt sé að veita þér þjónustu. Við varðveitum öll samskipti sem fara fram í vefspjallinu.'
        }
        
        text.classList.add('webchat-disclaimer')
        inputs.append(text)
      }
    },
  }

  method.init();
};

export default Chat;
